import { buildCreateApi, coreModule, reactHooksModule } from '@reduxjs/toolkit/query/react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import config from '../config';
import baseQueryWithAuth from './auth/baseQueryWithAuth';

export enum ApiTagTypes {
    account = 'account',
    accountJobMetrics = 'accountJobMetrics',
    app = 'app',
    appSecret = 'appSecret',
    experiments = 'experiments',
    experiment = 'experiment',
    experimentResults = 'experimentResults',
    favorites = 'favorites',
    job = 'job',
    members = 'members',
    remoteHosts = 'remoteHosts',
    resource = 'resource',
    resourceDeployKeys = 'resourceDeployKeys',
    resourcePermissions = 'resourcePermissions',
    resourceVersion = 'resourceVersion',
    result = 'result',
    resultNotes = 'resultNotes',
    sensitivityLabelCategories = 'sensitivityLabelCategories',
    tokens = 'tokens',
    user = 'user',
}

// TODO: Remove this interface when the backend is updated to return the new format
export interface IPaginatedResponseLegacy<T> {
    count: number;
    next: null | string;
    previous: null | string;
    results: T[];
}

// TODO: Remove this interface when the backend is updated to return the new format
export interface IPaginatedResponseExtendendLegacy<T> {
    count: number;
    current_page_number: number;
    object_count: number;
    page_count: number;
    page_size: number;
    links: {
        next: null | string;
        previous: null | string;
    };
    results: T[];
}

export interface IPaginatedResponse<T> {
    object_count: number;
    page_count: number;
    results: T[];
}

export interface IPaginatedBaseQuery {
    page?: number;
    page_size?: number;
}

// Using this "customCreateApi" magically fixes below build error:
// WebpackError: TypeError: Cannot destructure property 'store' of 'useReduxContext(...)' as it is null.
const customCreateApi = buildCreateApi(
    coreModule(),
    reactHooksModule({ hooks: { useSelector, useDispatch, useStore } }),
);

// initialize an empty api service that we'll inject endpoints into later as needed
export const baseApi = customCreateApi({
    tagTypes: Object.values(ApiTagTypes),
    baseQuery: baseQueryWithAuth,
    endpoints: () => ({}),
});

export function rewriteUrlIfDev(url: string): string {
    if (config.isDev) {
        return rewriteUrlToOrigin(url);
    }
    return url;
}

export function rewriteUrlToOrigin(url: string): string {
    const urlObj = new URL(url);
    return `${location.origin}${urlObj.pathname}${urlObj.search}`;
}
